var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3214 0.540619L6.00015 4.63616L1.67895 0.54062C1.57476 0.441874 1.43345 0.386399 1.28611 0.386399C1.13877 0.386399 0.997459 0.441874 0.893272 0.54062C0.789085 0.639366 0.730554 0.773294 0.730553 0.912942C0.730554 1.05259 0.789085 1.18652 0.893272 1.28526L5.21448 5.3808L0.893272 9.47633C0.789085 9.57508 0.730554 9.70901 0.730554 9.84866C0.730554 9.9883 0.789086 10.1222 0.893272 10.221C0.942389 10.2712 1.00229 10.3109 1.06895 10.3373C1.13561 10.3637 1.20747 10.3763 1.27969 10.3742C1.35191 10.3721 1.42281 10.3553 1.48762 10.325C1.55242 10.2947 1.60963 10.2516 1.65538 10.1986L5.97658 6.1031L10.3214 10.221C10.4255 10.3197 10.5669 10.3752 10.7142 10.3752C10.8615 10.3752 11.0028 10.3197 11.107 10.221C11.2112 10.1222 11.2698 9.9883 11.2698 9.84866C11.2698 9.70901 11.2112 9.57508 11.107 9.47633L6.78583 5.3808L11.107 1.28526C11.2112 1.18652 11.2698 1.05259 11.2698 0.912941C11.2698 0.773293 11.2112 0.639366 11.107 0.54062C11.0028 0.441874 10.8615 0.386399 10.7142 0.386398C10.5669 0.386399 10.4255 0.441874 10.3214 0.540619Z",
    fill: "#888C9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupClose);
export default __webpack_public_path__ + "static/media/popup-close.59b1f0c7babeafae1f66380b1432d7c8.svg";
export { ForwardRef as ReactComponent };